import React, { useState } from 'react';
import { WellbeingData } from '../../../types/wellbeing';
import { GutIcon } from '../CategoryIcons';

interface GutSymptomsModalProps {
  data: WellbeingData;
  onSave: (data: Partial<WellbeingData>) => void;
  onClose: () => void;
}

export const GutSymptomsModal: React.FC<GutSymptomsModalProps> = ({ data, onSave, onClose }) => {
  const [localData, setLocalData] = useState({
    abdominalPain: data.abdominalPain ?? 0,
    bloating: data.bloating ?? 0,
    rumbling: data.rumbling ?? 0,
    heartburn: data.heartburn ?? 0,
    nausea: data.nausea ?? 0,
    vomiting: data.vomiting ?? 0,
    lossOfAppetite: data.lossOfAppetite ?? 0,
    fullness: data.fullness ?? 0,
  });

  const Slider = ({
    label,
    value,
    onChange
  }: {
    label: string;
    value: number;
    onChange: (val: number) => void;
  }) => (
    <div style={{ marginBottom: '16px' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '6px',
      }}>
        <label style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a' }}>
          {label}
        </label>
        <span style={{ fontSize: '13px', fontWeight: '600', color: '#6B7FFF' }}>
          {value}/5
        </span>
      </div>
      <input
        type="range"
        min="0"
        max="5"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
        style={{
          width: '100%',
          height: '6px',
          cursor: 'pointer',
          accentColor: '#6B7FFF',
        }}
      />
    </div>
  );

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: '60px',
        overflowY: 'auto',
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          maxWidth: '500px',
          width: '100%',
          maxHeight: 'calc(100vh - 120px)',
          overflowY: 'auto',
          position: 'relative',
          marginBottom: '40px',
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #f0f4ff 0%, #e0e7ff 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <GutIcon />
          </div>

          <h2 style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#0f172a',
            margin: 0,
          }}>
            Objawy jelitowe
          </h2>
        </div>

        <Slider
          label="Ból brzucha"
          value={localData.abdominalPain}
          onChange={(v) => setLocalData({ ...localData, abdominalPain: v })}
        />

        <Slider
          label="Wzdęcia/Gazy"
          value={localData.bloating}
          onChange={(v) => setLocalData({ ...localData, bloating: v })}
        />

        <Slider
          label="Przelewanie"
          value={localData.rumbling}
          onChange={(v) => setLocalData({ ...localData, rumbling: v })}
        />

        <Slider
          label="Zgaga"
          value={localData.heartburn}
          onChange={(v) => setLocalData({ ...localData, heartburn: v })}
        />

        <Slider
          label="Nudności"
          value={localData.nausea}
          onChange={(v) => setLocalData({ ...localData, nausea: v })}
        />

        <Slider
          label="Wymioty"
          value={localData.vomiting}
          onChange={(v) => setLocalData({ ...localData, vomiting: v })}
        />

        <Slider
          label="Brak apetytu"
          value={localData.lossOfAppetite}
          onChange={(v) => setLocalData({ ...localData, lossOfAppetite: v })}
        />

        <Slider
          label="Uczucie pełności"
          value={localData.fullness}
          onChange={(v) => setLocalData({ ...localData, fullness: v })}
        />

        <button
          onClick={() => onSave(localData)}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '10px',
            border: 'none',
            background: 'linear-gradient(135deg, #6B7FFF 0%, #5A6EE6 100%)',
            color: 'white',
            fontSize: '15px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Gotowe ✓
        </button>
      </div>
    </div>
  );
};
